import { render, staticRenderFns } from "./notify-manage.vue?vue&type=template&id=e6d119ba&scoped=true"
import script from "./notify-manage.vue?vue&type=script&lang=js"
export * from "./notify-manage.vue?vue&type=script&lang=js"
import style0 from "./notify-manage.vue?vue&type=style&index=0&id=e6d119ba&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e6d119ba",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/frontend_coduck_manage_sbGx/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e6d119ba')) {
      api.createRecord('e6d119ba', component.options)
    } else {
      api.reload('e6d119ba', component.options)
    }
    module.hot.accept("./notify-manage.vue?vue&type=template&id=e6d119ba&scoped=true", function () {
      api.rerender('e6d119ba', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/system/notify-manage.vue"
export default component.exports